<template>
<div class="ctr-details my-5">
  <div class="top-section">
    <div class="img-wrapper">
      <b-button
        type="button"
        variant="primary"
        class="small btn-sm"
        @click="$refs.companyLogoFileInput.click()"
        ><i class="fas fa-edit"></i
      ></b-button>
      <input
        type="file"
        class="sr-only"
        ref="companyLogoFileInput"
        @change="uploadCompanyLogo"
      />
        <img
          class=""
          v-if="contractor_details.active_business.logo_url"
          :src="contractor_details.active_business.logo_url"
          alt="Company Logo"
        />
      <!-- <img :src="this.$root.serverBasePath + '/strata.png'" alt=""> -->
    </div>
    
    <div class="right-content ml-md-4">
      <h1 class="ctr-details">
        {{ contractor_details.full_name }}<br />
        <span>{{ contractor_details.active_business.company_name }}</span>
      </h1>
      
      <p class="py-1 mb-0">
        {{ formatPhoneForAustraliaBySpace(parseInt(contractor_details.active_business.business_phone)) }}
        <br />
        <span>{{ contractor_details.active_business.address }}, {{contractor_details.email}}</span>
      </p>
      
      <ul class="review-star">
        <li
          v-for="(n, idx) in Math.floor(
            contractor_details.active_business.ratings
          )"
          :key="'rat-fas-' + idx"
        >
         <i class="fas fa-star"></i>
        </li>

        <li
          v-for="(n, idx) in 4 -
          Math.floor(contractor_details.active_business.ratings)"
          :key="'rat-fas-' + idx"
        >
          <i class="fas fa-star checked"></i>
        </li>

        <li><i class="fas fa-star"></i></li>
        <li><span class="review-count"> {{ contractor_details.active_business.ratings_count }} Reviews</span></li>
      </ul>
      
    </div>
  </div>

  <div class="ctr-tags">
      <ul class="type-btn">
        <li
          v-for="category in contractor_details.active_business.categories"
          :key="'cat-' + category.id"
        >
          <button type="button" class="btn btn-secondary"><i class="fas fa-tag mr-2"></i>
            {{ category.name }}
          </button>
        </li>
      </ul>
  </div>
  </div>
</template>


<script>
import phoneNoMixin from "@mixins/phoneNoMixin.js";
import Swal from "sweetalert2";
// import image from "../../../../../assets/contractor.png";

export default {
  data() {
    return {
      contractor_details: {
        active_business: {
          logo_url: ""
        },
      },
      // image:image,
    };
  },
  mixins: [phoneNoMixin],
  mounted() {
    this.getDetails();
  },
  methods: {
    getDetails() {
      axios.post("api/contractor/compliance/getDetails", {
        load_active_business: true,
        load_active_business_logo: true,
        load_active_business_categories: true,
      }).then((response) => {
        this.contractor_details = response.data.contractor_details;
        this.contractor_details.active_business.logo_url = response.data.logo_url ? response.data.logo_url : this.$root.serverBasePath + "/strata.png";
      });
    },
    async uploadCompanyLogo(event) {
      this.$root.$data.bsLoader = true;
      if (!event.target.files.length) return;
      
      let formData = new FormData();
      formData.append("logo", event.target.files[0]);

     await axios
        .post("api/contractor/compliance/uploadLogo", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          this.contractor_details.active_business.logo_url = response.data.logo_url;
          this.getDetails();
          this.$root.$data.bsLoader = false;
           Swal.fire({
            title: "Logo Updated Successfully.",
            icon: "success",
            timer: 3000,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
          });
        });
    },
  },
};
</script>

<style scoped>
.top-section {
  display: flex;
  flex-wrap: wrap;
  gap: 0.7rem;
}

@media screen and (max-width: 767px) {
    .top-section {
        justify-content: center;
    }
}

.img-wrapper {
  position: relative;
  cursor: pointer;
  left: 10px;
}

.small {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 500ms linear;

}

.img-wrapper:hover .small {
  opacity: 1;
  transition: opacity 500ms linear;
}


</style>